import React from 'react';

import { DefaultLayout } from '@layouts/DefaultLayout';
import { Consulting } from '@layouts/Consulting';
import { FaqContainer } from '@layouts/FaqContainer/FaqContainer';
import { CustomHelmet } from '@components/CustomHelmet/CustomHelmet';
import useMetaData from '@utils/hooks/useMetaData';
import { PageUrls } from '@utils/constants/PageUrls';

const Faq: React.FC = () => {
	const { metaData } = useMetaData(PageUrls.FAQ);

	return (
		<>
			<CustomHelmet {...metaData} />
			<DefaultLayout scheme="light">
				<FaqContainer />
				<Consulting />
			</DefaultLayout>
		</>
	);
};

export default Faq;
